import {FormikConfig} from 'formik';

export const updateSettings: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (
    !values.isEmailSending &&
    !values.isSMSSending &&
    !values.isConnectSending
  ) {
    errors.isEmailSending = '通知手段は必須選択です';
  }

  return errors;
};
